import { render, staticRenderFns } from "./JobBoardTableComponent.vue?vue&type=template&id=d86988a8"
import script from "./JobBoardTableComponent.vue?vue&type=script&lang=ts"
export * from "./JobBoardTableComponent.vue?vue&type=script&lang=ts"
import style0 from "./JobBoardTableComponent.vue?vue&type=style&index=0&id=d86988a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports